import React, {useEffect, useState} from "react";
import v1 from "../Accests/images/yoga/v1.mp4";
import v2 from "../Accests/images/yoga/v2.mp4";
import y1 from "../Accests/images/yoga/y1.jpg";
import Y2 from "../Accests/images/yoga/y2jpg.jpg";
import Y3 from "../Accests/images/yoga/y3.jpg";
import b from "../Accests/images/yoga/b.jpg";
import b1 from "../Accests/images/yoga/b2.jpg";
import b2 from "../Accests/images/yoga/b1.jpg";
import a from "../Accests/images/yoga/a.jpg";
import y6 from "../Accests/images/yoga/y6.jpg";
import BottomActionBar from "./BottomActionBar";

const sections = [
    {
        title: "🧘 Meditation",
        description: "Find inner peace with guided meditation practices.",
        media: [
            { type: "image", src: y1, alt: "Meditation Pose 1", name: "" },
            { type: "image", src: Y2, alt: "Meditation Pose 2", name: "" },
            { type: "image", src: Y3, alt: "Meditation Pose 3", name: "" },
            { type: "image", src: y6, alt: "Meditation Pose 3", name: "" },
            { type: "video", src: v1, name: "" },
            { type: "video", src: v2, name: "" }
        ],
    },
    {
        title: "🧎‍♂️ Yoga",
        description: "Strengthen body and mind through ancient yoga techniques.",
        media: [
            { type: "image", src: b, name: "" },
            { type: "image", src: b1, name: "" },
            { type: "image", src: b2, name: "" },
        ],
    },
    {
        title: "👩‍⚕️ Ayurveda Specialist Doctor",
        description: "Heal naturally with our certified Ayurveda professionals.",
        media: [
            { type: "image", src: a, alt: "Ayurveda Treatment 1", name: "" },
        ],
    },
];

const WellnessSection = () => {

    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    return (

        <>
            <BottomActionBar visible={showActionBar} />

            <section className="bg-white py-12 px-4 sm:px-6 lg:px-16 mt-24 md:mt-28 lg:mt-10" id="wellness">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-gray-800">
                        🧘‍♀️ Meditation, Yoga & Ayurveda Specialist Doctor
                    </h2>
                    <p className="mt-3 text-lg text-gray-600 max-w-xl mx-auto">
                        Experience holistic healing with serene surroundings and expert guidance.
                    </p>
                </div>

                {sections.map((section, idx) => (
                    <div key={idx} className="mb-14">
                        <h3 className="text-2xl font-semibold text-green-700 mb-2">{section.title}</h3>
                        <p className="text-gray-500 mb-6">{section.description}</p>

                        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                            {section.media.map((item, index) => (
                                <div
                                    key={index}
                                    className="rounded-xl shadow-md overflow-hidden hover:scale-105 transition-transform duration-300 bg-white"
                                >
                                    {item.type === "image" ? (
                                        <img
                                            src={item.src}
                                            alt={item.alt}
                                            className="w-full h-60 object-cover"
                                        />
                                    ) : (
                                        <video
                                            src={item.src}
                                            controls
                                            className="w-full h-60 object-cover"
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </section>
        </>


    );
};

export default WellnessSection;
